import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function AuthDialog() {
  const { authOpen, setAuthOpen, login, register } = useApp();
  const [mode, setMode] = useState("signin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "signin") await login(email, password);
      else await register(email, password, name);
      setAuthOpen(false);
      setEmail(""); setPassword(""); setName("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Authentication failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={authOpen} onOpenChange={setAuthOpen}>
      <DialogContent className="rounded-none border border-black/10 max-w-md p-10" data-testid="auth-dialog">
        <DialogHeader>
          <div className="font-mono-brand text-xs uppercase tracking-[0.2em] text-[#FF3B30] mb-2">
            {mode === "signin" ? "Welcome back" : "Join Nova"}
          </div>
          <DialogTitle className="font-display font-black text-3xl leading-none tracking-tighter">
            {mode === "signin" ? "Sign in." : "Create account."}
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={submit} className="space-y-5 mt-6">
          {mode === "signup" && (
            <div>
              <label className="font-mono-brand text-[10px] uppercase tracking-[0.2em] text-neutral-500">Name</label>
              <Input
                value={name} onChange={(e) => setName(e.target.value)} required
                className="rounded-none border-0 border-b border-black/20 focus-visible:ring-0 focus-visible:border-black px-0 mt-1"
                data-testid="auth-name-input"
              />
            </div>
          )}
          <div>
            <label className="font-mono-brand text-[10px] uppercase tracking-[0.2em] text-neutral-500">Email</label>
            <Input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="rounded-none border-0 border-b border-black/20 focus-visible:ring-0 focus-visible:border-black px-0 mt-1"
              data-testid="auth-email-input"
            />
          </div>
          <div>
            <label className="font-mono-brand text-[10px] uppercase tracking-[0.2em] text-neutral-500">Password</label>
            <Input
              type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
              className="rounded-none border-0 border-b border-black/20 focus-visible:ring-0 focus-visible:border-black px-0 mt-1"
              data-testid="auth-password-input"
            />
          </div>
          <Button
            type="submit" disabled={loading}
            className="w-full rounded-none bg-black text-white hover:bg-[#FF3B30] font-mono-brand text-xs uppercase tracking-[0.2em] h-12"
            data-testid="auth-submit-btn"
          >
            {loading ? "..." : mode === "signin" ? "Sign in" : "Create account"}
          </Button>
          <button
            type="button" onClick={() => setMode(mode === "signin" ? "signup" : "signin")}
            className="w-full font-mono-brand text-xs uppercase tracking-[0.2em] text-neutral-500 hover:text-black"
            data-testid="auth-switch-mode"
          >
            {mode === "signin" ? "New here? Create an account →" : "← Already have an account? Sign in"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
